var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selectedArticleCategory",class:[
    'selectedArticleCategory',
    { 'selectedArticleCategory--disableGrayBackground': _vm.data.disableGrayBackground },
  ]},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"selectedArticleCategory__contentWrapper"},[_c('SectionContainer',{attrs:{"title":_vm.data.title,"small-title":_vm.data.smallTitle}},[_c('div',{staticClass:"selectedArticleCategory__content"},[_c('SliderTiles',{attrs:{"slides-per-view":"auto","content-type":"news","items":_vm.advices,"nav-buttons-type":"rounded"}})],1)])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }